import { FC, SVGProps } from 'react'

const SelfServiceMappingIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  style,
  size = 16,
  ...svgProps
}) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: size, height: size }}
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 14C13.5523 14 14 13.5523 14 13C14 12.4477 13.5523 12 13 12C12.4477 12 12 12.4477 12 13C12 13.5523 12.4477 14 13 14ZM13 16C14.6569 16 16 14.6569 16 13C16 11.3431 14.6569 10 13 10C11.3431 10 10 11.3431 10 13C10 14.6569 11.3431 16 13 16Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 14C3.55228 14 4 13.5523 4 13C4 12.4477 3.55228 12 3 12C2.44772 12 2 12.4477 2 13C2 13.5523 2.44772 14 3 14ZM3 16C4.65685 16 6 14.6569 6 13C6 11.3431 4.65685 10 3 10C1.34315 10 0 11.3431 0 13C0 14.6569 1.34315 16 3 16Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.83334 8.67758L4.2194 10.7106L5.44728 12.2894L7.87835 10.3985L10.7786 12.3321L11.888 10.6679L8.83334 8.63148V4.66667H6.83334V8.67758Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4C8.55229 4 9 3.55228 9 3C9 2.44772 8.55229 2 8 2C7.44772 2 7 2.44772 7 3C7 3.55228 7.44772 4 8 4ZM8 6C9.65685 6 11 4.65685 11 3C11 1.34315 9.65685 0 8 0C6.34315 0 5 1.34315 5 3C5 4.65685 6.34315 6 8 6Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SelfServiceMappingIcon
